export default "__VITE_ASSET__$g6FMym8__"